import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d665626e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }




export default /*#__PURE__*/_defineComponent({
  __name: 'CollectionPanel',
  props: ['collection'],
  setup(__props) {

const props = __props




return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: '/collection/' + props.collection.slug
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: props.collection.img,
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(props.collection.title), 1),
          _createElementVNode("h3", null, _toDisplayString(props.collection.subheading), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})